import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicEmptyAnnouncements({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      width={240}
      height={168}
      fill="none"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M178.5 155c-40.205-9.933-77 7.5-102 7.5-40.5 0-79.078-37.6-70.5-79C14.025 44.768 72.455 47.801 108 28c109.5-61 112.5 22 126 64s-13 73.5-55.5 63z"
        fill="#E9EDFB"
      />
      <path
        opacity={0.32}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.223 102.201c26.385 22.042 60.58 17.734 114.277 10.299 54.808-7.589 92.033 4.1 113.057 22.803-8.785 17.163-28.537 26.002-54.057 19.697-26.22-6.478-50.99-1.317-71.983 3.058-11.198 2.333-21.321 4.442-30.017 4.442-34.274 0-67.172-26.928-71.277-60.299z"
        fill="#8F9DD6"
      />
      <g filter="url(#pic-empty-announcements_svg__filter0_d_3102_16829)">
        <rect
          x={64.529}
          y={37.165}
          width={95}
          height={114}
          rx={3}
          transform="rotate(-8 64.53 37.165)"
          fill="#F9FAFA"
        />
      </g>
      <g filter="url(#pic-empty-announcements_svg__filter1_d_3102_16829)">
        <rect x={76} y={27} width={95} height={114} rx={3} fill="#fff" />
      </g>
      <rect x={86} y={44} width={24} height={12} rx={2} fill="#CCD2EE" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M86 65a1 1 0 011-1h73a1 1 0 011 1v4a1 1 0 01-1 1H87a1 1 0 01-1-1v-4zm0 12a1 1 0 011-1h73a1 1 0 011 1v4a1 1 0 01-1 1H87a1 1 0 01-1-1v-4zm1 12a1 1 0 00-1 1v4a1 1 0 001 1h28a1 1 0 001-1v-4a1 1 0 00-1-1H87z"
        fill="#E3E8E8"
      />
      <path
        d="M145.443 144.232l9.918-6.945 10.676 15.247a2 2 0 01-.491 2.786l-6.641 4.65a2.002 2.002 0 01-2.786-.491l-10.676-15.247z"
        fill="#6C7EC9"
      />
      <path
        d="M155.883 132.465s.001 0 0 0l-8.739-12.481c-1.267-1.811-3.953-2.287-5.767-1.017l-8.279 5.797a4.146 4.146 0 00-1.017 5.767l8.74 12.48a4.108 4.108 0 002.672 1.704 4.112 4.112 0 003.094-.687l8.279-5.797a4.147 4.147 0 001.017-5.766z"
        fill="#666"
      />
      <path
        d="M188.234 111.568a4.146 4.146 0 001.017-5.767l-4.566-6.522a4.148 4.148 0 00-5.768-1.016l-.913.639 9.316 13.305.913-.639h.001z"
        fill="#FF952B"
      />
      <path
        d="M156.375 133.653l31.867-3.645-27.866-39.797-14.326 28.697 10.325 14.745z"
        fill="#7E90DC"
      />
      <path
        d="M159.55 89.119a3 3 0 01.737-4.178l2.827-1.98a3 3 0 014.178.737l29.451 42.061a3 3 0 01-.737 4.178l-2.826 1.979a3 3 0 01-4.179-.737l-29.451-42.06z"
        fill="#6C7EC9"
      />
      <path
        opacity={0.7}
        d="M207.529 110.305l-8.345-2.836M204.585 90.836l-7.48 4.662M188.089 80.441l-1.379 8.705"
        stroke="#8F9DD6"
        strokeWidth={4}
        strokeLinecap="round"
      />
      <defs>
        <filter
          id="pic-empty-announcements_svg__filter0_d_3102_16829"
          x={60.917}
          y={22.332}
          width={117.165}
          height={133.336}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.207843 0 0 0 0 0.196078 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3102_16829" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_3102_16829" result="shape" />
        </filter>
        <filter
          id="pic-empty-announcements_svg__filter1_d_3102_16829"
          x={72}
          y={25}
          width={103}
          height={122}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.207843 0 0 0 0 0.196078 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3102_16829" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_3102_16829" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

SvgPicEmptyAnnouncements.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicEmptyAnnouncements.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicEmptyAnnouncements svgRef={ref} {...props} />
));
export default ForwardRef;
